"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDataForDevice = void 0;
const Account_1 = require("./Account");
const Patient_1 = require("./Patient");
const Weather_1 = require("./Weather");
const Device_1 = require("./Device");
exports.EmptyDataForDevice = {
    nucleusDataType: "dataForDevice",
    deviceInfo: Device_1.EmptyDeviceInfo,
    accountInfo: Account_1.EmptyAccount,
    patientInfo: Patient_1.EmptyPatient,
    weatherInfo: Weather_1.EmptyWeather
};
